"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @todo: Proxy need polyfills
 * https://github.com/GoogleChrome/proxy-polyfill
 */
function getErrorProxy(errors) {
    var errorProxyHandler = {
        get: function (obj, field) {
            return typeof obj[field] === 'undefined' ? {} : obj[field];
        },
        set: function (obj, field, value) {
            obj[field] = value;
            return true;
        }
    };
    return new Proxy(errors, errorProxyHandler);
}
exports.getErrorProxy = getErrorProxy;



// WEBPACK FOOTER //
// ./src/dist/commonjs/helpers/proxy.js